export default "__VITE_ASSET__3baed63b__"